import { useAsyncRetry } from 'react-use'
import { integrationsApi } from '@/api'
import type { IntegrationChannelItem } from '@/api/integrations/integrations.types'

export type UseWazzupCrmChannelsResult = {
  channels: IntegrationChannelItem[]
  isLoading: boolean
  error: string | null
  retry: () => void
}

/** GET /integrations/channels/{integrationId} */
export const useWazzupCrmChannels = (
  integrationId: number | null,
  enabled = true,
): UseWazzupCrmChannelsResult => {
  const state = useAsyncRetry(async () => {
    if (!enabled || integrationId == null || integrationId <= 0) {
      return [] as IntegrationChannelItem[]
    }

    const res = await integrationsApi.getChannels(integrationId)
    const raw = res?.data?.data ?? res?.data
    return Array.isArray(raw) ? raw : []
  }, [enabled, integrationId])

  return {
    channels: state.value ?? [],
    isLoading: Boolean(state.loading),
    error: state.error ? 'Не удалось загрузить каналы Wazzup' : null,
    retry: () => {
      void state.retry()
    },
  }
}
